import {openidCache, tokenCache} from "./cache"
import api from "./api"
import {
  getClientToken,
  getENV,
  getParamsFromUrl,
  isAlipay, isAndroidBrower,
  isBrower,
  isEmpty, isIphoneBrower,
  isWeixin, makeUrl,
  needRepeatLogin,
  queryStrBuilder, tokenPre
} from "./util";
import {VERSION5_2_4, VERSION5_3_0} from "@/lib/version";
import {Dialog} from "vant";
import {MAIN_COLOR} from "@/lib/config";
import {wechatService} from "@/services/wechat";
import {systemService} from "@/services/system";
import {patService} from "@/services/pat";
import {userService} from "@/services/user";


export const toPayPageMixin = {
  methods: {
    async _toPayPage(service, args) {
      const {obj: config} = await systemService.appidDetails(this.env.weixinPay);
      let options = getParamsFromUrl(location.href);
      options.hash = '/directPay' + queryStrBuilder({
        token: getClientToken().token,
        service,
        ...args
      });
      if (config.channel) {
        options.query.channel = config.channel;
        location.replace(makeUrl(options));
      }
    },
  },
}


export const isLoginMixin = {
  data() {
    return {
      path: ""
    }
  },
  created() {
    this.path = this.$route.path
    console.log(this.path)
    let openid = tokenCache.get();
    // if (!openid) {
    //
    //   this.$router.push({
    //     path:"/bindRelativePhone",
    //     query:{backPath:this.path}
    //   })
    // }
  },
  watch: {
    "$route": function () {
      this.path = this.$route.path
      // this.$router.push("/profile")

    }
  }
}
/**
 * 不用滚动组件，中间滚动区域的计算
 * @type {{mounted: (function())}}
 */
export const mainHeightMixin = {
  mounted() {
    this._calcMainHeight();
  },
  methods: {
    _calcMainHeight() {
      let h = 0;
      if (this.$refs.bottom) {
        h += 45;
      }
      if (this.$refs.footer) {
        h += 60;
      }
      if (this.$refs.footer50) {
        h += 50;
      }
      if (this.$refs.header) {
        h += 45;
      }
      if (this.$refs.main) {
        this.$refs.main.style.height = `${window.innerHeight - h}px`;
      }
    }
  }
}
/**滚动组件计算滚动高度**/
export const scrollHeightMixin = {
  data() {
    return {
      scrollHeight: 0
    }
  },
  created() {
    this._calcScrollHeight();
  },
  methods: {
    _calcScrollHeight() {
      let h = window.innerHeight - 45;
      if (this.bottomHeight) {
        h = h - this.bottomHeight;
      }
      this.scrollHeight = h;
    }
  }
}
/**
 * 判断是openid否绑定,后续继续扩展
 * 获得认证状态
 * **/
export const isBindMixin = {
  data() {
    return {
      hasOpenid: openidCache.get(),
      hasToken: tokenCache.get()
    }
  },
  methods: {
    /**
     * 登录用户的身份证是否完善
     * @returns {Promise<void>}
     * @private
     */
    async _hasPatIdCard(idCard) {
      if (idCard) {
        return Promise.resolve(true);
      }
      return Dialog.confirm({
        message: '证件号不能为空，是否去完善信息？',
        confirmButtonColor: MAIN_COLOR,
        confirmButtonText: '去完善',
        cancelButtonText: '再等等'
      }).then(() => {
        this._toPerfectPage();
        return false;
      }).catch(() => false);
    },

    /**
     * 去完善信息页
     * @private
     */
    _toPerfectPage() {
      this.$router.push({
        path: '/account/perfect',
        query: {back: this.$route.fullPath}
      })
    },


    async _handlerWeixin() {
      const Token = this.$route.query.openid || this.$route.query.openId;
      // 处理异常
      if (!Token) return bus.$emit('msg', '未正常获取token');
      if (!Token.startsWith(tokenPre)) return bus.$emit('msg', 'token格式不正确');
      // 微信登录
      const {code, obj, token, authorizedOpenId} = await patService.wechatLogin(Token);
      const openId = authorizedOpenId || obj.openId || obj.opeId || obj.openid;
      openidCache.set(openId);
      return {code, token, obj, openId};
    },


    // 是否登录成功
    /**
     *
     * @param successCb
     * @param bindCb
     * @param options
     * @param options.needSetSelfDialog 是否 需要设置默认就诊人弹窗
     * @param options.needAddCompatDialog 是否 需要添加就诊人弹窗
     * @returns {Promise<void>}
     * @private
     */
    async _handlerIsBind(successCb, bindCb, options = {needSetSelfDialog: true, needAddCompatDialog: true}) {
      const res = await this._isBind();// obj|string|boolean
      if (typeof res === 'object') {
        const {obj = {}} = await userService.compatJudge();
        // TODO 测试数据
        // const {obj = {}} = {haveSysCommonPatVo: false, haveDefaultSysCommonPatVo: false};
        if (obj.haveSysCommonPatVo !== true && options.needAddCompatDialog) {
          Dialog.confirm({
            message: "您还没有就诊人信息，请先添加就诊人",
            confirmButtonColor: MAIN_COLOR,
            confirmButtonText: '去添加'
          }).then(() => {
            this.$router.push({
              path: '/my/patient',
              query: {callback: this.$route.fullPath, action: "addCompat"}
            })
          }).catch(() => {
            this.nativeBack();
          })
        } else if (obj.haveDefaultSysCommonPatVo !== true && options.needSetSelfDialog) {
          Dialog.confirm({
            message: "您还没有设置默认就诊人，请先将一个就诊人设置为默认就诊人",
            confirmButtonColor: MAIN_COLOR,
            confirmButtonText: '去设置'
          }).then(() => {
            this.$router.push({path: '/my/patient', query: {callback: this.$route.fullPath, action: "setSelf"}})
          }).catch(() => this.$router.back())
        } else
          successCb(res);
      } else if (res === false) {
        if (isWeixin() || isAlipay()) bindCb();
        else await this._dialog();
      } else if (typeof res === 'string') {
        if (res === 'oauth2') {
          //this._redirectPreLogin();
        }
      }
    },

    _isBind() {
      const getPatInfo = () => {
        const {exclusiveCodeId, docId, callback = '', promoteCode = '', errCode = ''} = this.$route.query;
        return api("nethos.pat.info.get", {
          // clientStr: 999
        }).then((res) => {
          let {code, obj, msg} = res;

          // TODO
          // code = -1;


          if (code == 0 && !isEmpty(obj)) {
            return obj;
          } else if (needRepeatLogin(code)) {
            //bus.$emit('msg', msg);
            this._redirectPreLogin(exclusiveCodeId, docId, callback, promoteCode, errCode);
            return 'oauth2';
          } else {
            return false
          }
        }).catch(() => false)
      }

      const openid = getClientToken().token
      if (!openid) {
        return this._dialog();
      } else {
        return getPatInfo();
      }

    },
    _dialog() {
      const {exclusiveCodeId, docId, callback = '', promoteCode = '', errCode = ''} = this.$route.query;
      return Dialog.confirm({
        message: '您暂未登录或登录信息已过期，是否重新登录？',
        confirmButtonColor: MAIN_COLOR,
        cancelButtonText: '返回',
        confirmButtonText: '重新登录'
      }).then(() => {
        this._redirectPreLogin(exclusiveCodeId, docId, callback, promoteCode, errCode);
        return 'oauth2';
      }).catch(() => {
        this.$router.back()
        return 'back';
      })
    },
    _redirectPreLogin(exclusiveCodeId, docId, callback = '', promoteCode = '', errCode = '') {
      this.$router.replace({
        path: '/account/prelogin',
        query: {callback: callback || this.$route.fullPath, exclusiveCodeId, docId, promoteCode, errCode}
      });
    },
    _redirectLogin(exclusiveCodeId = '') {
      this.$router.replace({
        path: "/bindRelativePhone",
        query: {backPath: this.$route.fullPath, callback: this.$route.fullPath, exclusiveCodeId}
      });
    },
    _replaceLogin(exclusiveCodeId = '', openId = '', docId = '', promoteCode = '') {
      this.$router.replace({
        path: "/bindRelativePhone",
        query: {
          backPath: this.$route.query.callback,
          callback: this.$route.query.callback,
          exclusiveCodeId,
          openId,
          docId,
          promoteCode
        }
      });
    },
    /**
     *
     * @param docId
     * @param exclusiveCodeId 免费图文咨询专属码
     * @param openId
     * @param callback
     * @param promoteCode
     * @private
     */
    _redirectLoginDoc(docId, exclusiveCodeId, openId = '', callback = '', promoteCode = '') {
      this.$router.replace({
        path: "/scanBind",
        query: {backPath: callback || this.$route.fullPath, docId, exclusiveCodeId, openId, promoteCode}
      });
    }
  }
}
/**
 * 患者，医生，科室头像错误路径处理
 * @type {{methods: {__avaError(*): void}}}
 */
export const avaErrorMixin = {
  data() {
    return {
      TEAM_DEFAULT_AVA: require('../assets/team.default.png'),
      NEWS_DEFAULT_PIC: require('../assets/default-thumb@3x.png'),
      DOC_DEFAULT_AVA: require('../assets/doctor.default.png'),
      BOOK_DOC_DEFAULT_AVA: require('../assets/bookdoc.default.png')
    }
  },
  methods: {
    __hosError(e) {
      let dom = e.target, src = this.NEWS_DEFAULT_PIC;
      dom.src = src;
    },
    __avaError(e) {
      let dom = e.target, dataset = dom.dataset, src = "./static/img/pat.m.jpg";
      dataset && dataset.gender && (['f', 'm'].indexOf(dataset.gender.toLowerCase()) >= 0) && (src = `./static/img/pat.${dataset.gender.toLowerCase()}.jpg`);
      dom.src = src;
    },
    __docError(e) {
      let dom = e.target, dataset = dom.dataset, src = require('../assets/doctor.default.png');
      dom.src = src;
    },
    __deptError(e) {
      let dom = e.target, src = require('../../static/img/default.png');
      dom.src = src;
    },
    __newsError(e) {
      let dom = e.target, src = this.NEWS_DEFAULT_PIC;
      dom.src = src;
    },
    __teamAvaError(e) {
      e.target.src = this.TEAM_DEFAULT_AVA;
    },
    __bookDocAvaError(e) {
      e.target.src = this.BOOK_DOC_DEFAULT_AVA;
    }
  }
}
/**
 * 团队头像错误路径处理
 * @type {{methods: {teamAvaError(*): void}}}
 */
export const teamAvaErrorMixin = {
  methods: {
    teamAvaError(e) {
      e.target.src = require('../assets/team.default.png');
    }
  }
}
/**
 * jssdk
 * @type {{data(): *, created(): void, methods: {getJssdkConfig(): Promise<undefined>}}}
 */
export const jssdkMixin = {
  data() {
    return {
      jssdkMixin_jssdkConfig: null
    }
  },
  methods: {
    async jssdkMixin_getJssdkConfig() {
      /*const debug = false;
      if (this.jssdkMixin_jssdkConfig) {
        wx.config({...this.jssdkMixin_jssdkConfig, debug});
        return true;
      }
      let appid = getENV().appid,
        ret = await api('smarthos.wechat.jsapiticket.get', {
          reqUrl: location.href.split('#')[0],
          appid
        });
      if (ret.code == 0) {
        this.jssdkMixin_jssdkConfig = ret.obj;
        wx.config({...this.jssdkMixin_jssdkConfig, debug});
        return true;
      }
      return false;*/
    }
  }
}
/*android 输入框自动滚动至可视区域*/
export const scrollIntoViewMixin = {
  created() {
    this.scrollIntoView_timer = null;
    if (window.device === 'android') {
      this.scrollIntoView_timer = setInterval((res) => {
        let tag = document.activeElement.tagName.toLowerCase();
        if (tag === 'input' || tag == 'textarea') {
          document.activeElement.scrollIntoViewIfNeeded();
        }
      }, 300);
    }
  },
  beforeDestroy() {
    clearInterval(this.scrollIntoView_timer);
    this.scrollIntoView_timer = null;
  }


}
/**
 * 返回处理
 * @type {{created(): void, methods: {doBackMixin_doBack(): void, doBackMixin_getJssdkConfig(): Promise<void>}}}
 */
export const doBackMixin = {
  methods: {
    isStartHash() {
      return window.startHash === location.hash;
    },
    doBackMixin_doBack() {
      if (this.isMobile) {
        if (location.hash === window.startHash) this.nativeBack();
        else this.$router.go(-1);
      } else if (isWeixin()) {
        if (this.isStartHash()) {
          // wechatService.closeWindow(this.appid);
          this.$router.replace('/');
        } else {
          this.$router.go(-1);
        }
      } else
        this.$router.go(-1);
      // const his = new history().get();
      // Log('his', his);
      /*if (his.length == 1) {
        if (isBrower('micromessenger')) {
          Log('微信关闭');
          wx && wx.closeWindow();
        } else if (isBrower('android') || isBrower('iphone')) {
          Log('原生返回');
          this.nativeBack();
        }
      } else {
        Log('vue返回');
      }*/
      /*if (history.length == 1) {
        wx && wx.closeWindow();
      }
      else if (historyCache.get() == this.$route.path) {
        wx && wx.closeWindow();
      }
      else {
        this.$router.go(-1)
      }*/
    },
    async doBackMixin_getJssdkConfig() {
      //await this.jssdkMixin_getJssdkConfig();
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/mixin.js